import { useRef, useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { EmojiPicker } from "./EmojiPicker";

export function ChatComposer({ onSend, onTyping, disabled = false }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const submit = async (e) => {
    e && e.preventDefault();
    const val = text.trim();
    if (!val || busy) return;
    setBusy(true);
    try {
      await onSend(val);
      setText("");
      inputRef.current && inputRef.current.focus();
    } finally {
      setBusy(false);
    }
  };

  const insertEmoji = (emoji) => {
    setText((prev) => prev + emoji);
    setTimeout(() => inputRef.current && inputRef.current.focus(), 0);
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setText(v);
    if (v && onTyping) onTyping();
  };

  return (
    <form
      onSubmit={submit}
      className="flex items-center gap-2 q-glass border-t border-white/10 rounded-none sm:rounded-b-3xl p-3"
      data-testid="chat-composer"
    >
      <EmojiPicker onSelect={insertEmoji} disabled={disabled || busy} />
      <input
        ref={inputRef}
        data-testid="composer-input"
        className="q-input flex-1"
        placeholder="Escribe un mensaje…"
        value={text}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        }}
        disabled={disabled || busy}
        maxLength={2000}
        autoComplete="off"
      />
      <button
        type="submit"
        data-testid="composer-send"
        disabled={disabled || busy || !text.trim()}
        className="q-btn-primary !px-4 !py-2.5 rounded-full flex items-center gap-1"
        aria-label="Enviar"
      >
        {busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
      </button>
    </form>
  );
}
